import MissingInvitation from './MissingInvitation.template';

export default MissingInvitation;